import Select from '@blocks/Select'
import { desktop, tablet } from '@styles/mixins'
import React, { useRef } from 'react'
import { ValueType } from 'react-select'
import styled, { css } from 'styled-components'

export default function SalonNominationsSort({ archive }: Props) {
    const sort = useRef<ReturnType<ArchiveHookSortFn<Jury.Resources.Nomination>>>()

    return (
        <Select 
            id="sort" 
            name="sort"
            label="Sort"
            background="#fff"
            height="s"
            isClearable
            options={[
                { label: `Highest Score`, value: "score:reversed" },
                { label: `Lowest Score`, value: "score" }
            ]} 
            onChange={
                (option: ValueType<{ label: string, value: "score" | "score:reversed" }, false>) => {
                    if (!option?.value) {
                        sort.current?.reset()
                        return
                    }
                    
                    sort.current = archive.sort(sortByScore, option.value === "score:reversed")
                    sort.current.set()
                }
            } 
        /> 
    )
}

const SortWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    & > *:not(:last-child) {
        margin-bottom: 10px;
    }

    ${tablet(css`
        flex-direction: row;
        align-items: center;
        
        & > *:not(:last-child) {
            margin-right: 15px;
            margin-bottom: 0;
        }
    `)}

    ${desktop(css`
        width: 300px;
    `)}
`

const sortByScore: CompareFunction<Jury.Resources.Nomination> = (a, b) => {
    const voteA = a.vote?.score || 0
    const voteB = b.vote?.score || 0
    return voteA - voteB
}

interface Props {
    archive: ArchiveHookResponse<Jury.Resources.Nomination>
}